import type { PlaycastEnvironmentEnum } from '@playcastdotio/CoreTypes';

export const FORCE_LEGAL_EMBED_ERROR_PARAM = 'embedError';

export const isReleaseEnvironment = (environment: PlaycastEnvironmentEnum): boolean =>
  environment === 'production';

export const shouldForceLegalEmbedError = (
  searchParams: URLSearchParams,
  environment: PlaycastEnvironmentEnum,
): boolean => {
  if (isReleaseEnvironment(environment)) {
    return false;
  }

  const value = searchParams.get(FORCE_LEGAL_EMBED_ERROR_PARAM);
  return value === '1' || value === 'true';
};
